import * as React from "react"
import {Fragment, useEffect} from "react"
import {Helmet} from "react-helmet-async";
import {Box, Divider, Typography} from "@mui/material";
import {AlertSeeker, IconSeeker} from "@components/ui"

import {dsColorNew} from "@palette";
import {hasSearchedCommonFilters, isLoadingCommonFilters} from "@signals";
import {pageToggles} from "../../@signals";
import AppWrapperPageTitle from "./Title";
import AppWrapperPageNotificationsBlock from "./NotificationsBlock";
import AppWrapperPageNoData from "./NoData";
import AppWrapperPageNotificationsGroupedBlock from "./NotificationsGroupedBlock";
import AppWrapperPageGlobalMessages from "./globalMessages";
import AppWrapperPageToggleBar from "./ToggleBar";


export default function AppWrapperPage({ title, notifications=[], globalMessages=[], isEmpty=false, children, ...props }) {

	const hasFilters = !!props?.filters
	const toggles = pageToggles.value
	const hasToggles = toggles && (toggles.buyBox || toggles.authorizedSeller || toggles.productsInStock || toggles.withShippingPrice || toggles.topSales)

	useEffect(() => {
		if (hasFilters && isLoadingCommonFilters.value) {
			hasSearchedCommonFilters.value = true
		}
	})

	return <>
		<Helmet>
			<title>{ props?.head || (title ? `Dataseekers Retail | ${title}` : 'Dataseekers Retail') }</title>
			<meta name="robots" content="noindex, nofollow" />
			<meta name="googlebot" content="noindex, nofollow" />
		</Helmet>

		{ title && <AppWrapperPageTitle title={title} subtitle={props?.subtitle} {...props?.titlePageProps} /> }

		{ !!props?.showBeta && <AlertSeeker severity="warning" sx={{mb: 1}} title="BETA VERSION" disableAccordion>
			This app is in beta version. If you find any bug, please report it to us.
		</AlertSeeker> }

		<AppWrapperPageToggleBar />

		{ hasFilters && <Box sx={{
			backgroundColor: '#fff',
			borderBottom: `1px solid ${dsColorNew.grayBorder}`,
			p: '24px 32px',
			pt: hasToggles ? '24px' : '40px',
			mx: -5,
			mt: -1,
			overflow: 'hidden',
			'& .MuiOutlinedInput-root': { backgroundColor: dsColorNew.filterInputBg },
			'& .MuiInputBase-root': { backgroundColor: dsColorNew.filterInputBg },
			'& .rs-picker-toggle': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
			'& .rs-picker-cascader .rs-btn': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
			'& .rs-picker-select .rs-btn': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
			'& .rs-picker-default .rs-picker-toggle': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
			'& .MuiChip-root': { backgroundColor: dsColorNew.appBlue, color: '#fff' },
			'& .MuiChip-deleteIcon': { color: '#fff' },
			'& .MuiAutocomplete-tag:not(.MuiChip-root)': { backgroundColor: dsColorNew.appBlue, color: '#fff' },
			'& .rs-picker-value-count': { backgroundColor: `${dsColorNew.appBlue} !important`, color: '#fff !important' },
		}}>
			{ !!globalMessages.length && <AppWrapperPageGlobalMessages globalMessages={globalMessages} /> }
			{ props?.filters }
		</Box> }

		{ !hasFilters && props?.filters && <Box sx={{ mb: 2 }}>
			{ props?.filters }
		</Box> }

		{ !!notifications.length && notifications.map(({ title, children, isGrouped=false, ...config }, idx) => <Fragment key={idx}>
			{ !isGrouped
				? <AppWrapperPageNotificationsBlock title={title} notifications={children} {...config} />
				: <AppWrapperPageNotificationsGroupedBlock title={title} {...config}>
					{children}
				</AppWrapperPageNotificationsGroupedBlock>
			}
		</Fragment>) }

		{ hasFilters && !hasSearchedCommonFilters.value && <Box sx={{
			display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
			py: 12, flexGrow: 1,
		}}>
			<IconSeeker icon="search" sx={{ fontSize: 64, color: '#D1D5DB', mb: 3 }} />
			<Typography sx={{ fontSize: 20, fontWeight: 500, color: '#9CA3AF' }}>
				Apply filters and search
			</Typography>
			<Typography sx={{ fontSize: 13, color: '#D1D5DB', mt: 0.5 }}>
				Select your filters above and click Search to view results
			</Typography>
		</Box> }

		{ (!hasFilters || hasSearchedCommonFilters.value) && <Box sx={{ mt: 3 }}>
			{ !!isEmpty && <AppWrapperPageNoData
				title={props?.emptyMessage || 'Data Not Found'}
				description={props?.emptyDescription || ''}
				{...props?.noDataProps}
			/> }

			<Box sx={{ display: isEmpty ? 'none' : 'block' }}>{children}</Box>
		</Box> }
	</>
}